import { Field } from 'common/fields/entities/field'
import { createSuggestionsMiddleware } from 'components/MCTextEditor/shared/middleware/suggestions'
import { SliceType } from 'components/MCTextEditor/slice/types'

import { VariableFilter } from '../adapter'

const START_CHAR = '{'

export const createInsertVariable = (getFields: () => Field[]) => {
  return createSuggestionsMiddleware(SliceType.VARIABLE_INPUT, START_CHAR, (expression, range) => {
    const query = expression.slice(1)
    const fields = getFields()
    if (fields.some((field) => VariableFilter(field.caption, query))) {
      return { range, data: { fields, query } }
    }
    return null
  })
}
